import { Reveal, SectionLabel } from "../site/Reveal";
import { PreferenceChart, AromaChart, TraysChart, FanChart, FatChart, NoPreferenceNote } from "../site/Charts";
import { FOOTNOTE } from "../../data/products";

const Tile = ({ className = "", tag, title, color, children, testId, delay = 0 }) => (
  <Reveal delay={delay} className={`rounded-[24px] border border-[var(--line)] bg-[var(--paper)] p-6 md:p-8 flex flex-col transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_24px_50px_-30px_rgba(14,42,31,0.4)] ${className}`}>
    <div data-testid={testId} className="flex flex-col h-full">
      <p className="eyebrow text-[11px]" style={{ color }}>{tag}</p>
      <h3 className="font-display text-2xl md:text-[1.7rem] text-[var(--forest)] mt-2 mb-6 leading-tight">{title}</h3>
      <div className="mt-auto">{children}</div>
    </div>
  </Reveal>
);

export const ScienceBento = () => (
  <section id="science" data-testid="science-section" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36">
    <div className="grid lg:grid-cols-12 gap-8 mb-14">
      <div className="lg:col-span-3"><SectionLabel index="04">Evidence</SectionLabel></div>
      <div className="lg:col-span-9">
        <Reveal as="h2" className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[var(--forest)] leading-[1.05]">
          Science you can <span className="italic">read in the trough.</span>
        </Reveal>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5">
      <Tile className="md:col-span-6 lg:col-span-7" tag="PALATIVA · Two-choice test" title="Animals choose PALATIVA feed" color="#1F6B45" testId="bento-preference">
        <PreferenceChart h={280} />
        <NoPreferenceNote />
      </Tile>
      <Tile className="md:col-span-6 lg:col-span-5" tag="PALATIVA · Pelleting" title="Aroma that survives the pellet mill" color="#4E9A1F" testId="bento-aroma" delay={0.08}>
        <AromaChart h={280} />
      </Tile>
      <Tile className="md:col-span-2 lg:col-span-4" tag="OPTIBITE · Shrimp" title="Less feed left on check trays" color="#0B5F8A" testId="bento-trays">
        <TraysChart h={230} />
      </Tile>
      <Tile className="md:col-span-2 lg:col-span-4" tag="AVITIVA · LYSOBOOST" title="Young birds digest fat better" color="#B4471A" testId="bento-fat" delay={0.08}>
        <FatChart h={230} />
      </Tile>
      <Tile className="md:col-span-2 lg:col-span-4" tag="AVITIVA · SENZIA" title="Golden yolks, measured on the fan" color="#C77A12" testId="bento-fan" delay={0.16}>
        <FanChart h={230} />
      </Tile>
    </div>
    <p className="mt-6 text-xs text-[var(--muted)] max-w-3xl">{FOOTNOTE}</p>
  </section>
);
